export class NavController {
  private get elOverlay(): HTMLDivElement | null {
    return document.getElementById( 'overlay-nav-home' ) as HTMLDivElement | null;
  }

  public onClickOverlayShow(): void {
    this.elOverlay?.classList.add( 'show' );
  }

  public onClickOverlayClose(): void {
    this.elOverlay?.classList.remove( 'show' );
  }
}
